import "./addpostmiddleform.css";
import {
  React,
  Box,
  useState,
  memo,
  useCallback,
  useEffect,
  Button,
  Select,
  Dialog,
  toast,
  ChooseMedia,
  ReactPlayer,
  LoadingSpinner,
  useGetAllScreensMutation,
  useGetDurationMutation,
  GetCookie,
} from "../../../Libraries/Post/AddNewPost/Child/AddPostMiddleForm/index";

const AddPostMiddleForm = (props) => {
  const [getAllScreens, { isLoading }] = useGetAllScreensMutation();
  const [getAllDuration, { isLoading: loading }] = useGetDurationMutation();

  const [opendialog, setopendialog] = useState(false);
  const [Screens, setScreens] = useState([]);
  const [durationoptions, setdurationoptions] = useState([]);
  const [defaultScreens, setdefaultScreens] = useState([]);

  //These Callback functions will save the extra
  //re-renders of component
  const handleselectscreen = useCallback(
    (e) => {
      setdefaultScreens(e);
      const data = e.map((eachdata) => ({ ser_screen_id: eachdata.value }));
      props.handleChangeselectedScreens(data);
    },
    [props]
  );

  const handledurationoptions = useCallback(
    (e) => {
      props.handleChangeselectedDuration(e?.value);
    },
    [props]
  );

  const handlesetPostStatus = useCallback(
    (e) => {
      props.handleChangePostStatus(e.target.value);
    },
    [props]
  );

  const handleChnagePostTitle = useCallback(
    (e) => {
      props.handleChangePosttitle(e.target.value);
    },
    [props]
  );

  const filterByReference = (arr1, arr2) => {
    let res = [];
    res = arr1.filter((el) => {
      return arr2.find((element) => {
        return element.ser_screen_id === el.value;
      });
    });
    return res;
  };
  useEffect(() => {
    const getAllScreensFunc = async () => {
      const layoutsdata = new FormData();
      layoutsdata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      layoutsdata.append("security_token", GetCookie("es_token"));
      const res = await getAllScreens(layoutsdata).unwrap();
      if (
        res.connection === "true" &&
        res.message === "Screens available" &&
        res.status === "true"
      ) {
        const so = res.data.map((screensoption) => ({
          label: screensoption.txt_screen_name,
          value: screensoption.ser_screen_id,
        }));
        setScreens(so);
      } else {
        toast.error(res.message);
      }
    };

    try {
      getAllScreensFunc();
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  }, [getAllScreens]);

  useEffect(() => {
    if (!props?.data?.selectedScreens.track && props?.data?.selectedScreens) {
      setdefaultScreens(filterByReference(Screens, props.data.selectedScreens));
    } else {
      const data = props?.data.selectedScreens?.track.map((eachdata) => ({
        ser_screen_id: eachdata.value,
      }));
      props.handleChangeselectedScreens(data);
      setdefaultScreens(props.data.selectedScreens.track);
    }
  }, [props, Screens]);

  useEffect(() => {
    const getDurationFunc = async () => {
      const layoutsdata = new FormData();
      layoutsdata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      layoutsdata.append("security_token", GetCookie("es_token"));
      const res = await getAllDuration(layoutsdata).unwrap();
      if (
        res.connection === "true" &&
        res.message === "Durations available" &&
        res.status === "true"
      ) {
        setdurationoptions(res.data);
      } else {
        toast.error(res.message);
        setdurationoptions([]);
      }
    };
    try {
      getDurationFunc();
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  }, [getAllDuration]);

  //onDialoghide
  const hideDialog = () => {
    setopendialog(false);
  };

  const mediaselectionfooter = (
    <React.Fragment>
      <Button variant="contained" className="mt-3 capitalized fs-14 fw-bold" onClick={hideDialog}>
        Submit
      </Button>
    </React.Fragment>
  );

  return (
    <>
      {isLoading || loading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mb: 2, ml: 4, mr: 3 }}>
        <div className="row surface-0 border-round p-2">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="w-full mt-2">
              <Select
                isMulti="true"
                options={Screens}
                value={defaultScreens}
                onChange={handleselectscreen}
                isClearable={true}
                placeholder="Select screen"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                // styles={{
                //   menuPortal: (provided) => ({
                //     ...provided,
                //     zIndex: 9999,
                //   }),
                //   menu: (provided) => ({
                //     ...provided,
                //     zIndex: 9999,
                //   }),
                //   control: (base, state) => ({
                //     ...base,
                //     background: "#1776EE",
                //     color: "white",
                //   }),
                //   placeholder: (defaultStyles) => {
                //     return {
                //       ...defaultStyles,
                //       color: "#ffffff",
                //     };
                //   },
                //   dropdownIndicator: (base) => ({
                //     ...base,
                //     color: "white", // Custom colour
                //   }),
                //   singleValue: (provided, state) => ({
                //     ...provided,
                //     color: "black",
                //     backgroundColor: "red",
                //   }),
                // }}
              />
            </div>

            <div className="w-full mt-3">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="posttitle"
                  value={props.data.PostTitle}
                  onChange={handleChnagePostTitle}
                  placeholder="Type Post title here"
                />
              </div>
            </div>

            {props?.data.finalfile && (
              <>
                <div className="w-full mt-3">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      readOnly={true}
                      ref={props.posttype}
                      id="posttype"
                      value={props?.data.finalfile?.type}
                    />
                  </div>
                </div>

                <div className="w-full mt-3">
                  <div className="form-group">
                    <Select
                      options={durationoptions}
                      onChange={handledurationoptions}
                      value={durationoptions?.filter(
                        (dopt) =>
                          dopt.value === props?.data.selectedDuration && dopt
                      )}
                      isDisabled={props?.posttype?.current?.value === "Video"}
                      isClearable={true}
                      placeholder="Select Duration"
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
              </>
            )}

            <div className="w-full mt-4">
              <span className="mr-2">Post Status</span>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="true"
                  checked={props.data.PostStatus === "true"}
                  onChange={handlesetPostStatus}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  Active
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="false"
                  checked={props.data.PostStatus === "false"}
                  onChange={handlesetPostStatus}
                />
                <label className="form-check-label" htmlFor="inlineRadio2">
                  Non Active
                </label>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="row">
              <div className="col d-flex justify-content-end">
                <Button onClick={() => setopendialog(true)} variant="contained" className="capitalized fs-14 fw-bold">
                  Choose Media
                </Button>
              </div>
            </div>

            <div
              className="d-flex justify-content-center outdivofreactplayer mb-3"
              style={{ height: "240px" }}
            >
              <div className="w-full">
                {props?.data?.finalfile &&
                props?.data?.finalfile?.type === "Image" ? (
                  <img
                    alt="img"
                    src={props?.data?.finalfile.link}
                    width="100%"
                    height="100%"
                    style={{
                      border: "dotted",
                      borderRadius: "5px",
                    }}
                  />
                ) : props?.data?.finalfile?.type === "Video" ? (
                  <ReactPlayer
                    url={props?.data?.finalfile?.link}
                    height="100%"
                    width="100%"
                    controls
                  />
                ) : null}
              </div>
            </div>
          </div>

          <Dialog
            visible={opendialog}
            style={{ width: "1200px", height: "600px" }}
            breakpoints={{ "960px": "75vw", "640px": "100vw" }}
            header={"Select Media"}
            modal
            maximizable={true}
            footer={mediaselectionfooter}
            onHide={hideDialog}
          >
            <ChooseMedia
              setfinalfile={props?.handleChangefinalfile}
              finalfile={props?.data.finalfile}
            />
          </Dialog>
        </div>
      </Box>
    </>
  );
};

export default memo(AddPostMiddleForm);
